// This import loads the firebase namespace along with all its type information.
import TargetGroup from './target-group-model'

export async function load_targetGroups(): Promise<TargetGroup[]> {
  throw 'Not implemented'
}

export async function delete_targetGroup(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_targetGroup(): Promise<TargetGroup> {
  throw 'Not implemented'
}
